import { Subject } from 'rxjs'
import { postFormData } from '../util'
import { modalController } from '../ui'

const Controller = {
    el: null,
    inputs: [],
    errorMessageEl: null,

    inputKeys: [],
    isFormDirty: false,
    action: '',

    onErrorEvent: null,
    onSucccessEvent: null,

    onError: null,
    onSucccess: null,

    init,
    resetForm
}

export default function createController(selector, onSucccess, onError) {
    const Obj = Object.create(Controller)
    Obj.init(selector, onSucccess, onError)
    return Obj
}

function init(selector, onSucccess, onError) {
    if (typeof selector === 'string') {
        this.el = document.querySelector(selector)
    } else {
        this.el = selector
    }

    if (!this.el) {
        return
    }
    this.errorMessageEl = this.el.querySelector('.js-form-errors')
    this.inputs = this.el.querySelectorAll('[name]')
    this.inputs = Array.from(this.inputs)
    this.inputs = this.inputs.reduce((acc, input) => {
        if (acc[input.name]) {
            return acc
        }

        acc[input.name] = input
        return acc
    }, {})

    this.inputKeys = Object.keys(this.inputs)
    this.action = this.el.action

    this.onErrorEvent = new Subject()
    this.onSucccessEvent = new Subject()

    this.onError = onError || handleError
    this.onSucccess = onSucccess || handleReturn
    this.onError = this.onError.bind(this)
    this.onSucccess = this.onSucccess.bind(this)
    this.resetForm = this.resetForm.bind(this)

    this.onErrorEvent.subscribe(this.onError)
    this.onSucccessEvent.subscribe(this.onSucccess)

    this.el.addEventListener('submit', handleSubmit.bind(this))

    resetForm.call(this)
}

function handleSubmit(evt) {
    evt.preventDefault()

    const formData = new FormData(this.el)

    postFormData(this.action, formData)
        .then(data => JSON.parse(data))
        .then(data => {
            this.onSucccessEvent.next({ data, formData })
        })
        .catch(data => {
            data = JSON.parse(data)
            this.onSucccessEvent.next({ data, formData })
        })
}

// function handleSubmit (evt) {
//     evt.preventDefault()

//     const formData = getFormValueObj.call(this)

//     // post(this.action, formData)
//     //     .then(data => JSON.parse(data))
//     //     .then(data => {
//     //         this.onSucccessEvent.next({ data, formData })
//     //     })
//     //     .catch(err => {
//     //         this.onErrorEvent.next(err)
//     //     })

//     const testSuccessData = {
//         success: true,
//         msg: 'Success',
//         fields: []
//     }

//     // const testErrorData = {
//     //     success: false,
//     //     msg: 'you done fucked up',
//     //     fields: {
//     //         fName: 'First name is required',
//     //         lName: 'Last name is required',
//     //         email: 'Email address is required',
//     //         phone: 'Phone number is required',
//     //         message: 'Message is required'
//     //     }
//     // }
//     this.onSucccessEvent.next({ data: testSuccessData, formData })
// }

function handleReturn({ data }) {
    if (!data) {
        return
    }

    resetForm.call(this)

    if (data.success) {
        if (data.redirect) {
            window.location = data.redirect
            return
        }

        let message = `<p>Thank you</p>`
        if (data.message) {
            message = `<p>${data.message}</p>`
        }

        modalController.addModal({
            id: 'ThankYou',
            content: message + '<button class="o-btn js-modal-close">Close</button>',
            header: 'Thank You'
        })
        modalController.openModal('ThankYou')
        clearForm.call(this)
        return
    }

    if (data.message) {
        this.errorMessageEl.innerHTML = `<p>${data.message}</p>`
        this.errorMessageEl.classList.add('active')
    }

    const errorKeys = Object.keys(data.data)
    errorKeys.forEach(key => {
        if (!~this.inputKeys.indexOf(key)) {
            return
        }

        const el = this.inputs[key]
        const formGroupEl = el.closest('.o-form__group')
        if (!formGroupEl) {
            return
        }

        const message = formGroupEl.querySelector('.o-form__message label')
        if (message) {
            message.innerHTML = data.data[key]
        }

        formGroupEl.classList.add('has-error')
    })
}

function handleError() {
    handleReturn.call({
        success: false,
        msg: 'There was an issue connecting to the server, please try again.',
        fields: {}
    })
}

function resetForm() {
    this.isFormDirty = false
    this.errorMessageEl.classList.remove('active')
    this.errorMessageEl.innerHTML = ''
    this.inputKeys.forEach(key => {
        const el = this.inputs[key]
        const formGroupEl = el.closest('.o-form__group')
        if (!formGroupEl) {
            return
        }

        const message = formGroupEl.querySelector('.o-form__message label')
        if (message) {
            message.innerHTML = ''
        }

        formGroupEl.classList.remove('has-error')
    })
}

function clearForm() {
    this.el.reset()
}
